<app-section #parentSection
             class="offer-modifications offer-modifications--beesafe"
             *ngIf="sectionVisible"
             [title]="title"
             [key]="key"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [formConfig]="formConfig">

    <ng-template #section>

        <div class="offer-modifications__content">
            <div *ngFor="let mod of visibleModifications" >
                <app-radio-tile [bean]="bean"
                                [errorsMap]="formFactoryService.errorsMap"
                                [control]="formGroup.controls[mod.code]"
                                [fieldConfig]="formFactoryService.fieldConfig(mod.code, formConfig)"
                                (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)">
                </app-radio-tile>
            </div>

            <app-ac-variants-coverages-table *ngIf="isTableVisible" [visibleModifications]="modifications"></app-ac-variants-coverages-table>

            <app-number-step-input *ngIf="offerModificationsService.vehicleValueModificationEnabled"
                                   class="offer-modifications__vehicle-value"
                                   [bean]="bean"
                                   [errorsMap]="formFactoryService.errorsMap"
                                   [control]="formGroup.controls['vehicleValue']"
                                   [fieldConfig]="formFactoryService.fieldConfig('vehicleValue', formConfig)"
                                   (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)">
            </app-number-step-input>

            <button class="btn btn--clear offer-modifications__compare-link-btn"
                    (click)="compareAcCoveragesDialog()">
                {{'SELECTED_OFFER_COMPONENT.offerDetails' | translate}}
                <span class="material-icons">arrow_right</span>
            </button>
        </div>

    </ng-template>
</app-section>

